/**
 * @author Srijan Shakya
 * @description https://marvelapp.com/4g4b5dg/screen/60580195
 */

import React from 'react';
import isEmpty from 'ramda/src/isEmpty';
import length from 'ramda/src/length';
import slice from 'ramda/src/slice';
import Pagination from '@components/@core/Pagination';
import withNavigate from '~/hocs/withNavigate';
import EmployeeQuotaList from './EmployeeQuotaList';

class Report extends React.PureComponent {
    state = { current: 1, per: 25 };

    render() {
        const { quota_templates } = this.props.data;
        const { current, per } = this.state;

        const from = (current - 1) * per;
        const to = current * per;
        const totalPage = Math.ceil(length(quota_templates) / per);
        const selected = slice(from, to, quota_templates);

        return (
            <div className="quota-reports">
                <p className="dsl-b18 bold my-4">Actuals</p>
                <div className="report-item">
                    <div className="d-flex-5 text-start text-400 mb-2">
                        <p className="dsl-m12 text-400">Goals</p>
                    </div>
                    <div className="d-flex-1 text-end mb-2 desktop-screen">
                        <p className="dsl-m12 mb-1 text-400">Employees</p>
                        <p className="dsl-m12 mb-1 text-400">assigned</p>
                    </div>
                    <div className="d-flex-2 text-end mb-2 desktop-screen">
                        <p className="dsl-m12 mb-1 text-400">Actuals</p>
                        <p className="dsl-m12 mb-1 text-400">saved</p>
                    </div>
                    <div className="d-flex-2 text-end mb-2 desktop-screen">
                        <p className="dsl-m12 mb-1 text-400">% Actuals</p>
                        <p className="dsl-m12 mb-1 text-400">saved</p>
                    </div>
                    <div className="d-flex-2 text-end mb-2 desktop-screen">
                        <p className="dsl-m12 mb-1 text-400">Low</p>
                    </div>
                    <div className="d-flex-2 text-end mb-2 desktop-screen">
                        <p className="dsl-m12 mb-1 text-400">High</p>
                    </div>
                    <div className="d-flex-2 text-end mb-2 desktop-screen">
                        <p className="dsl-m12 mb-1 text-400">Average</p>
                    </div>
                    <div className="d-flex-1 mb-2" />
                </div>
                {selected?.map((quota, index) => {
                    const { id, name, users, actual_count, actual_high, actual_low, actuals_percent, actual_average } = quota;
                    return (
                        !isEmpty(quota) && (
                            <div className="report-item d-flex ssm-column cursor-pointer py-4" key={index}>
                                <div className="d-flex-5 text-start text-400 ssm-b-2 mb-0" onClick={() => this.props.navigate(`/hcm/report-quota-employee/${id}/${this.props.tab}`)}>
                                    <p className="dsl-b14 mb-0 text-400">{name}</p>
                                </div>
                                <div className="d-flex-1 text-end ssm-left ssm-b-2 mb-0 employees-detail d-flex jc-end ssm-jc-start">
                                    <label className="dsl-b14 mobile-screen w-40">Employee Assigned</label>
                                    <p className="dsl-b14 mb-0 text-400">{users?.length || 'NA'}</p>
                                    <div className="employees-detail-modal">
                                        {users && (
                                            <EmployeeQuotaList
                                                data={users}
                                                quota={quota}
                                                navigate={this.props.navigate}
                                                location={this.props.location}
                                                onReport={this.props.onReport}
                                                onShowModal={() => this.props.onShowModal(quota)}
                                            />
                                        )}
                                    </div>
                                </div>
                                <div className="d-flex-2 d-flex ssm-b-2 mb-0 d-flex jc-end ssm-jc-start">
                                    <label className="dsl-b14 mobile-screen w-40">Actual Saved</label>
                                    <p className="dsl-b14 mb-0 text-400">{actual_count}</p>
                                </div>
                                <div className="d-flex-2 ssm-b-2 mb-0 d-flex jc-end ssm-jc-start">
                                    <label className="dsl-b14 mobile-screen w-40">Actual Saved %</label>
                                    <p className="dsl-b14 mb-0 text-400">{Number(actuals_percent).toFixed(2) || 'NA'}</p>
                                </div>
                                <div className="d-flex-2 ssm-b-2 mb-0 d-flex jc-end ssm-jc-start">
                                    <label className="dsl-b14 mobile-screen w-40">Low</label>
                                    <p className="dsl-b14 mb-0 text-400">{Number(actual_low).toFixed(2) || 'NA'}</p>
                                </div>
                                <div className="d-flex-2 ssm-b-2 mb-0 d-flex jc-end ssm-jc-start">
                                    <label className="dsl-b14 mobile-screen w-40">High</label>
                                    <p className="dsl-b14 mb-0 text-400">{Number(actual_high).toFixed(2) || 'NA'}</p>
                                </div>
                                <div className="d-flex-2 ssm-b-2 mb-0 d-flex jc-end ssm-jc-start">
                                    <label className="dsl-b14 mobile-screen w-40">Average</label>
                                    <p className="dsl-b14 mb-0 text-400">{Number(actual_average).toFixed(2) || 'NA'}</p>
                                </div>
                                <div className="d-flex-1 ssm-b-2 mb-0" />
                            </div>
                        )
                    );
                })}
                <Pagination current={current} total={totalPage} onPer={(e) => this.setState({ per: e })} onChange={(e) => this.setState({ current: e })} />
            </div>
        );
    }
}

const ReportWithNavigate = withNavigate(Report);

export default ReportWithNavigate;
